module.exports = "/Candle@2x-74810f5d5d8316dfa6b8c960b840d9fd.png";